<template>
  <!-- On an outlined card, Vuetify 4's color prop tints the text and border,
       so the selected side gets its grey background from a class. -->
  <v-card
    @click="$emit('set-side')"
    class="my-2"
    :class="{ 'bg-grey-lighten-2': selected }"
    variant="outlined"
  >
    <v-row class="mx-4 my-1 justify-space-between">
      <h2 class="py-4" v-html="formatSide" />
      <v-speed-dial
        v-if="showEditButton"
        v-model="sideEditMenu"
        location="left center"
        :open-on-hover="true"
        class="my-3"
      >
        <template #activator="{ props }">
          <v-btn
            v-bind="props"
            color="primary"
            icon
            variant="text"
            size="x-small"
          >
            <v-icon v-if="sideEditMenu"> mdi-close </v-icon>
            <v-icon v-else> mdi-pencil </v-icon>
          </v-btn>
        </template>
        <v-tooltip location="bottom">
          <template #activator="{ props }">
            <v-btn
              color="info"
              v-bind="props"
              @click="$emit('change-side')"
              icon
              variant="text"
              size="x-small"
            >
              <v-icon>mdi-pencil</v-icon>
            </v-btn>
          </template>
          <span>Change Side</span>
        </v-tooltip>
        <v-tooltip location="bottom">
          <template #activator="{ props }">
            <v-btn
              color="red"
              v-bind="props"
              @click="$emit('remove-side')"
              icon
              variant="text"
              size="x-small"
            >
              <v-icon>mdi-delete</v-icon>
            </v-btn>
          </template>
          <span>Remove Side</span>
        </v-tooltip>
      </v-speed-dial>
    </v-row>
  </v-card>
</template>

<script lang="ts">
import { EpigraphicUnitSide, MarkupUnit } from '@oare/types';
import { defineComponent, PropType, ref, computed } from 'vue';

export default defineComponent({
  props: {
    side: {
      type: String as PropType<EpigraphicUnitSide>,
      required: true,
    },
    sideMarkup: {
      type: Array as PropType<MarkupUnit[]>,
      required: false,
    },
    selected: {
      type: Boolean,
      required: true,
    },
    showEditButton: {
      type: Boolean,
      default: true,
    },
  },
  emits: ['set-side', 'change-side', 'remove-side'],
  setup(props) {
    const sideEditMenu = ref(false);

    const formatSide = computed(() => {
      if (props.sideMarkup) {
        if (props.sideMarkup.map(markup => markup.type).includes('uncertain')) {
          return `${props.side}<sup>?</sup>`;
        } else if (
          props.sideMarkup
            .map(markup => markup.type)
            .includes('isEmendedReading')
        ) {
          return `${props.side}<sup>!</sup>`;
        }
        return props.side;
      }
      return props.side;
    });

    return {
      sideEditMenu,
      formatSide,
    };
  },
});
</script>
